/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage}  from "react-intl";
import { Link } from "react-router-dom";

/* Helpers, constants, custom methods, internal libraries */
import { AADVANTAGE_PROGRAM_DATA } from "constants/appConstants";

/* Components */
import { ReactComponent as PackageIcon } from "../../../resources/images/aadvantagePassIcons/package-icon.svg";
import { ReactComponent as Miles } from "../../../resources/images/aadvantagePassIcons/icon-award-miles.svg";
import { ReactComponent as Points } from "../../../resources/images/aadvantagePassIcons/icon-loyalty-points-alt.svg";
import { ReactComponent as EmptyStar } from "../../../resources/images/aadvantagePassIcons/icon-loyalty-points.svg";
import { ReactComponent as CheckIn } from "../../../resources/images/aadvantagePassIcons/icon-counter-checkin.svg";
import { ReactComponent as SeatUpgrade } from "../../../resources/images/aadvantagePassIcons/icon-seat-upgrade.svg";
import { ReactComponent as Suitcase } from "../../../resources/images/aadvantagePassIcons/icon-baggage-suitcase.svg";
import { ReactComponent as Seat } from "../../../resources/images/aadvantagePassIcons/icon-seat.svg";

/* Styles */
import styles from "./styles.js"

const packageOptions = [
  {
    icon: <PackageIcon />,
    description: <FormattedMessage id="aadvantage.gold.status"/>
  },
  {
    icon: <Miles />,
    description: <FormattedMessage id="aadvantage.miles.100k"/>
  },
  {
    icon: <Points />,
    description: <FormattedMessage id="aadvantage.points.15k"/>
  },
];

const SinglePackage = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  const renderMessage = (id) => (
    <FormattedMessage
      id={id}
      values={{
        bold: (chunks) => <span className={classes.boldedText}>{chunks}</span>,
      }}
    />
  );

  const statusBenefitsOptions = [
    { icon: <EmptyStar />, description: renderMessage("aadvantage.earn.40pct") },
    { icon: <CheckIn />, description: renderMessage("aadvantage.priority.checkin") },
    { icon: <SeatUpgrade />, description: renderMessage("aadvantage.upgrades.24h") },
    { icon: <Suitcase />, description: renderMessage("aadvantage.bag.free") },
    { icon: <Seat />, description: <FormattedMessage id="aadvantage.seats.pref.mcx"/> },
  ];

  return (
    <div className={classes.container}>
      <h2 className={classes.title}><FormattedMessage id="aadvantage.pass.package.details"/></h2>
      <p className={classes.subtitle}>
        <FormattedMessage id="aadvantage.pass.package.details.desc"/>
      </p>

      <div className={classes.card}>
      <div className={classes.headerBanner}></div>
      <div className={classes.content}>
        <div className={classes.titleContainer}>
          <FormattedMessage id="aadvantage.pass.gold"/>
        </div>

        <div className={classes.sections}>
          <div className={classes.section}>
            <div className={classes.sectionTitle}><FormattedMessage id="aadvantage.pass.includes"/></div>
            <ul className={classes.ulLists}>
              {packageOptions.map((option, index) => (
                <li key={index} className={classes.listItem}>
                  {option.icon}
                  {option.description}
                </li>
              ))}
            </ul>
          </div>

          <div className={classes.section}>
            <div className={classes.sectionTitle}><FormattedMessage id="aadvantage.pass.status.includes"/></div>
              <ul className={classes.ulLists}>
                {statusBenefitsOptions.map((option, index) => (
                <li key={index} className={classes.listItem}>
                    {option.icon}
                    {option.description}
                  </li>
                ))}
              </ul>
            <div className={classes.moreLink}><FormattedMessage id="aadvantage.pass.more"/></div>
          </div>
        </div>
      </div>

      <div className={classes.footer}>
        <div>
          <div className={classes.priceText}><FormattedMessage id="aadvantage.pass.price"/></div>
          <div className={classes.price}>{AADVANTAGE_PROGRAM_DATA.goldPrice}</div>
        </div>
        <Link to={AADVANTAGE_PROGRAM_DATA.explorePackageUrl} target="_blank" className={classes.explorePackage}>
          <FormattedMessage id="aadvantage.pass.explore.package"/>
        </Link>
      </div>
     </div>
    </div>
  )
};

export default SinglePackage;
